function isAcknowledged(id: string) {
  const cached = sessionStorage.getItem(`ditto-alert-${id}`)

  if (cached === null) {
    sessionStorage.setItem(`ditto-alert-${id}`, 'false')
    return false
  }

  return cached === 'true'
}

/** Utility function to find the first alert, given a list of alert public IDs,
 *  that has not been acknowledged this session.
 */
export function findFirstUnacknowledgedAlert(ids: string[]) {
  return ids.findIndex((id) => !isAcknowledged(id))
}

/** Utility function to set an alert as acknowledged in the sessionStore */
export function acknowledgedAlert(id: string) {
  sessionStorage.setItem(`ditto-alert-${id}`, 'true')
}
